import { Component } from '@angular/core';

@Component({
  selector: 'app-audit-fee-mpr',
  templateUrl: './audit-fee-mpr.component.html',
  styleUrls: ['./audit-fee-mpr.component.scss']
})
export class AuditFeeMPRComponent {

}
